import React from 'react'
import Spinner from '@cloudscape-design/components/spinner'
import Box from '@cloudscape-design/components/box'
import Container from '@cloudscape-design/components/container'

/**
 * LoadingSpinner component
 * Displays a Cloudscape spinner with optional message
 */
const LoadingSpinner = ({ message = 'Loading...', size = 'normal' }) => {
  return (
    <Container>
      <Box textAlign="center" padding="l">
        <Spinner size={size === 'medium' ? 'normal' : size} />
        {message && (
          <Box variant="p" padding={{ top: 's' }}>
            {message}
          </Box>
        )}
      </Box>
    </Container>
  )
}

export default LoadingSpinner
